<template>
  <div>
    <div class="d-flex justify-space-between align-top sm-gap">
      <div>
        <div class="text-body-1"><span class="font-weight-bold">{{ item.quantite_souhaite
            }}x</span> {{
              item.nom }}</div>
      </div>
      <div>
        <div class="justify-self-end text-body font-weight-bold">
          <span v-if="item.current_price">{{ item.current_price }}€</span>
          <span v-else>
            Gratuit
            <span v-if="item.cart?.prix_regulier"
              class="text-caption text-medium-emphasis text-decoration-line-through ml-1">
              {{ item.cart?.prix_regulier }}€
            </span>
          </span>
        </div>
      </div>

    </div>

    <div class="pl-4" v-for="size in selected_sizes" :key="size.id">
      - {{ size.quantite_souhaite }}x Taille {{ size.nom }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  computed: {
    selected_sizes() {
      return this.item.sizes.filter((size) => size.quantite_souhaite > 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.thumbnail_cart {
  width: 50px;
  border-radius: 10px;
}
</style>